import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      // Navigation will be handled by App.js RootRedirect
      window.location.href = '/';
    } else {
      setError(result.error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090b] px-4 py-8">
      <div className="w-full max-w-md">
        <div className="bg-[#18181b] border border-[#27272a] rounded-lg p-6 sm:p-8">
          <div className="mb-6 sm:mb-8 text-center">
            <h1 className="text-2xl sm:text-3xl font-bold text-[#fafafa] tracking-tight" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
              BuenasCompras END
            </h1>
            <p className="text-[#a1a1aa] mt-2 text-sm sm:text-base" style={{ fontFamily: 'Manrope, sans-serif' }}>Inicia sesión para continuar</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-[#fafafa] text-sm sm:text-base">Usuario</Label>
              <Input
                id="username"
                data-testid="login-username-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-[#09090b] border-[#27272a] text-[#fafafa] focus:border-[#2563eb] h-11 sm:h-10"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#fafafa] text-sm sm:text-base">Contraseña</Label>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#09090b] border-[#27272a] text-[#fafafa] focus:border-[#2563eb] h-11 sm:h-10"
                required
              />
            </div>

            {error && (
              <div data-testid="login-error-message" className="text-[#ef4444] text-sm p-3 bg-[#ef4444]/10 border border-[#ef4444]/20 rounded">
                {error}
              </div>
            )}

            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full bg-[#2563eb] hover:bg-[#1d4ed8] text-white h-11 sm:h-10 text-base"
            >
              {loading ? 'Ingresando...' : 'Ingresar'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
